export default "__VITE_ASSET__C9TYUCLh__"